// extracted by mini-css-extract-plugin
module.exports = {"row":"JournalDeliveryTableHead_row__1T5th","rowWithoutApproving":"JournalDeliveryTableHead_rowWithoutApproving__159H0","centered":"JournalDeliveryTableHead_centered__1SO77"};